import { render } from "./designReferenceFormPrint.vue?vue&type=template&id=15a03bec"
import script from "./designReferenceFormPrint.vue?vue&type=script&lang=js"
export * from "./designReferenceFormPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__